import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useDebounce } from '@/hooks'
import { ModalRushPage, SettingsLayout } from '@/ui'
import { useWebsitesQuery } from '@/api/useWebsitesQuery'
import { HUB_SETTINGS_PATH, useNavigateBack } from '@/libs'
import { usePagesQuery } from '@/layouts/pages/api/usePagesQuery'
import { HubSettingsProvider, HubSettingsSidebar } from '@/layouts/hub-settings/widgets'

const STATIC_PAGES = [
  { slug: 'home' },
  { slug: 'store' },
  { slug: 'leaderboard' },
  { slug: 'achievements' },
  { slug: 'daily-rewards' },
  { slug: 'loyalty-program' },
  { slug: 'redeem-coupon' },
]

export const HubSettingsOutlet = () => {
  const back = useNavigateBack({ fallback: HUB_SETTINGS_PATH })
  const { companyId, gameId } = useParams() as { companyId: string; gameId: string }
  const { data: websites = [] } = useWebsitesQuery(companyId, gameId)
  const website = websites[0]
  const { data: pages = [], isLoading } = usePagesQuery(companyId, gameId, {
    limit: 100,
  })
  const delayedLoading = useDebounce(isLoading, 500)
  const loading = isLoading || delayedLoading

  const slug2page = useMemo(() => new Map(pages.map(page => [page.slug, page])), [pages])
  const primal = useMemo(() => STATIC_PAGES.map(({ slug }) => slug2page.get(slug)).filter(p => !!p), [pages])
  const others = useMemo(() => pages.filter(page => !STATIC_PAGES.some(sp => sp.slug === page.slug)), [pages])

  const sidebar = useMemo(
    () => (website ? <HubSettingsSidebar website={website} pages={{ loading, primal, others }} /> : undefined),
    [website, loading, primal, others],
  )

  return (
    <HubSettingsProvider website={website} pages={{ loading, primal, others }}>
      <ModalRushPage back={back}>{props => <SettingsLayout {...props} sidebar={sidebar} />}</ModalRushPage>
    </HubSettingsProvider>
  )
}
